import { render } from "./AdminUsersPaginated.vue?vue&type=template&id=18a696e2"
import script from "./AdminUsersPaginated.vue?vue&type=script&lang=js"
export * from "./AdminUsersPaginated.vue?vue&type=script&lang=js"

import "./AdminUsersPaginated.vue?vue&type=style&index=0&id=18a696e2&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__